__turbopack_context__.v({
  "back-button": "signup-module-scss-module__CEn6La__back-button",
  "blinq-logo": "signup-module-scss-module__CEn6La__blinq-logo",
  "footer-first-step": "signup-module-scss-module__CEn6La__footer-first-step",
  "form-intro": "signup-module-scss-module__CEn6La__form-intro",
  "form-stack": "signup-module-scss-module__CEn6La__form-stack",
  "heading": "signup-module-scss-module__CEn6La__heading",
  "logo-link": "signup-module-scss-module__CEn6La__logo-link",
  "main-pane": "signup-module-scss-module__CEn6La__main-pane",
  "main-pane-content": "signup-module-scss-module__CEn6La__main-pane-content",
  "main-pane-header": "signup-module-scss-module__CEn6La__main-pane-header",
  "need-help": "signup-module-scss-module__CEn6La__need-help",
  "side-illustration": "signup-module-scss-module__CEn6La__side-illustration",
  "subtitle": "signup-module-scss-module__CEn6La__subtitle",
});
